import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import { inmunetApi } from '../../../api';

import { setAlergenos, setAplicaciones, setComentarios, setConcentracion, setFase, setFecha, setFrasco, setLado, setSitio, setTipo, setVolumenAlergeno, setVolumenTotal } from '../../../redux/slices/inmunoterapia/inmunoterapiaSlice';

import { useForm, useFormValidation } from '../../../hooks';
import { useInmunoterapiaTipo } from '../hooks/useInmunoterapiaTipo';
import { useInmunoterapiaFase } from '../hooks/useInmunoterapiaFase';
import { useInmunoterapiaSitio } from '../hooks/useInmunoterapiaSitio';
import { useInmunoterapiaLado } from '../hooks/useInmunoterapiaLado';
import { useInmunoterapiaReaccion } from '../hooks/useInmunoterapiaReaccion';
import { useInmunoterapiaFrasco } from '../hooks/useInmunoterapiaFrasco';
import { useInmunoterapiaFrascoData } from '../hooks/useInmunoterapiaFrascoData';
import { usePacienteInmunoterapiaCrear } from '../hooks/usePacienteInmunoterapiaCrear';
import { dangerNotification } from "../../../redux/slices/ui";

import { DateTimeInput, Error, Forbidden, LightButton, Loader, ModalContainer, MultiFormAplicacionInmunoterapiaNueva, PrimaryButton, ReactMultiValueSelectInput, ReactSelectSingleInput, TextAreaInput, TextInput } from '../../../components';
import { PushInmunoterapiaModal } from '../../Modals/PushInmunoterapiaModal';
import { NotificacionInmunoterapiaModal } from '../../Modals/NotificacionInmunoterapiaModal';

import { distanciaAlSiguienteDia } from '../../../helpers/dia';

import styles from '../PacienteConsulta.module.css';

export const InmunoterapiaNueva = ({ dataFlag = false, data = null, dataTipos = [], dataFases = [], dataFrascos = [], dataSitiosFlag = true, dataSitios = [], dataLados = [], dataAlergenos = [], dataFrecuencia, dataDiasSemana, dataPostMigracion, handleCancelar, id }) => {

    const dispatch = useDispatch();

    const { permisos } = useSelector(state => state.auth);

    const { createInmunoterapiaMutation: { mutate: createInmunoterapia, isPending } } = usePacienteInmunoterapiaCrear(id);

    const [faseReset, setFaseReset] = useState(true);

    const [frascoReset, setFrascoReset] = useState(true);

    const [sitioReset, setSitioReset] = useState(true);

    const [alergenosReset, setAlergenosReset] = useState(true);

    const [aplicacionesReset, setAplicacionesReset] = useState(true);

    const [userAction, setUserAction] = useState(false);

    const [userActionDone, setUserActionDone] = useState(false);

    const [userActionRedux, setUserActionRedux] = useState(false);

    const [statusPushModal, setStatusPushModal] = useState(false);

    const [dataPushModal, setDataPushModal] = useState(false);

    const [statusNotificacionModal, setStatusNotificacionModal] = useState(false);

    const [notificacion, setNotificacion] = useState(false);

    const [notificacionMsg, setNotificacionMsg] = useState('');

    const [toDoAccion, setToDoAccion] = useState(0);

    const { tipo, fase, fecha, frasco, concentracion, volumenAlergeno, volumenTotal, sitio, lado, alergenos, aplicaciones, comentarios, onInputChange, onMultipleInputChange } = useForm({ tipo: (data !== null) ? data.tipo : '', fase: (data !== null) ? data.fase : '', fecha: (data !== null) ? data.fecha : '', frasco: (data !== null) ? data.frasco : '', concentracion: (data !== null) ? data.concentracion : '', volumenAlergeno: (data !== null) ? data.volumenAlergeno : '', volumenTotal: (data !== null) ? data.volumenTotal : '', sitio: (data !== null) ? data.sitio : '', lado: (data !== null) ? data.lado : '', alergenos: (data !== null) ? data.alergenos : [], aplicaciones: (data !== null) ? data.aplicaciones : [], comentarios: (data !== null) ? data.comentarios : '' });

    const { isFormValid: isFormStaticValid, formValidationStatus: formStaticValidationStatus, formFields: formStaticFields, startFormValidation: startFormStaticValidation, setFormFieldValidation: setFormStaticFieldValidation, setMultipleFormFieldValidation: setMultipleFormStaticFieldValidation } = useFormValidation([{field: 'fecha', default: (dataFlag || (data !== null && data.fecha !== '')) ? true : false}, {field: 'concentracion', default: true}, {field: 'volumenAlergeno', default: true}, {field: 'volumenTotal', default: true}, {field: 'comentarios', default: true}]);

    const { isFormValid: isFormTipoValid, formValidationStatus: formTipoValidationStatus, formFields: formTipoFields, startFormValidation: startFormTipoValidation, setFormFieldValidation: setFormTipoFieldValidation } = useFormValidation([{field: 'tipo', default: (dataFlag || (data !== null && data.tipo !== '')) ? true : false}]);

    const { isFormValid: isFormFaseValid, formValidationStatus: formFaseValidationStatus, formFields: formFaseFields, startFormValidation: startFormFaseValidation, setFormFieldValidation: setFormFaseFieldValidation } = useFormValidation([{field: 'fase', default: (dataFlag || (data !== null && data.fase !== '')) ? true : false}]);
    
    const { isFormValid: isFormFrascoValid, formValidationStatus: formFrascoValidationStatus, formFields: formFrascoFields, startFormValidation: startFormFrascoValidation, setFormFieldValidation: setFormFrascoFieldValidation } = useFormValidation([{field: 'frasco', default: (dataFlag || (data !== null && data.frasco !== '')) ? true : false}]);

    const { formValidationStatus: formAlergenosValidationStatus, formFields: formAlergenosFields, setFormFieldValidation: setFormAlergenosFieldValidation } = useFormValidation([{field: 'alergenos', default: true}]);

    const { formValidationStatus: formAplicacionesValidationStatus, setFormFieldValidation: setFormAplicacionesFieldValidation } = useFormValidation([{field: 'aplicaciones', default: true}]);

    const { tipoQuery: { isLoading, isError, data: tipos } } = useInmunoterapiaTipo();

    const { faseQuery: { data: fases, refetch: refetchFase } } = useInmunoterapiaFase(tipo);

    const { sitioQuery: { data: sitioData, refetch: refetchSitio } } = useInmunoterapiaSitio(tipo);

    const { ladoQuery: { isLoading: isLoadingLado, isError: isErrorLado, data: ladoData, refetch: refetchLado } } = useInmunoterapiaLado(tipo);

    const { reaccionQuery: { isLoading: isLoadingReaccion, isError: isErrorReaccion, data: reaccion, refetch: refetchReaccion } } = useInmunoterapiaReaccion(tipo);

    const { frascoQuery: { data: frascos, refetch: refetchFrasco } } = useInmunoterapiaFrasco(tipo, fase);

    const { frascoDataQuery: { data: frascoData, refetch: refetchFrascoData } } = useInmunoterapiaFrascoData(id, tipo, fase, frasco, fecha, lado);

    const handleResetFase = () => {
        setFaseReset(false);
        setTimeout(() => {
            setFaseReset(true);
        }, 1);
    }

    const handleResetSitio = () => {
        setSitioReset(false);
        setTimeout(() => {
            setSitioReset(true);
        }, 1);
    }

    const handleResetFrasco = () => {
        setFrascoReset(false);
        setTimeout(() => {
            setFrascoReset(true);
        }, 1);
    }

    const handleResetAlergenos = () => {
        setAlergenosReset(false);
        setTimeout(() => {
            setAlergenosReset(true);
        }, 1);
    }

    const handleResetAplicaciones = () => {
        setAplicacionesReset(false);
        setTimeout(() => {
            setAplicacionesReset(true);
        }, 1);
    }

    const handleAddAplicacion = async () => {
        try {
  
            let resp = await inmunetApi.post(`/inmunoterapia/aplicacion-data/${id}`, { tipo, fase, fecha: aplicaciones[aplicaciones.length - 1].fecha, lado: aplicaciones[aplicaciones.length - 1].ladoAplicacion, dosis: aplicaciones[aplicaciones.length - 1].dosis });
            handleOnFieldChange({ target: { name: 'aplicaciones', value: [ ...aplicaciones, { id: moment().unix() + Math.random(), fecha: resp.data.aplicacion.fecha, dosis: resp.data.aplicacion.dosis, ladoAplicacion: (typeof resp.data.aplicacion.ladoAplicacion !== 'undefined') ? resp.data.aplicacion.ladoAplicacion : 'Derecho', reaccion: resp.data.aplicacion.reaccion, realizado: resp.data.aplicacion.realizado, validation: false } ] } });
            handleResetAplicaciones();
    
        } catch (error) {
    
            dispatch(dangerNotification('Error al agregar aplicación, intenta nuevamente'));
    
        }
    }

    const handleOnFieldChange = (e) => {
        setUserAction(true);
        //Determinación de campo modificado
        if(['tipo', 'fase', 'frasco'].includes(e.target.name)){
            setUserActionDone(true);
        }
        setUserActionRedux(true);
        onInputChange(e);
    }

    const showPushModal = ({ id, fecha, element }) => {
        document.activeElement.blur();
        setDataPushModal({ id, fecha, element });
        setStatusPushModal(true);
    }

    const aceptPushModal = () => {
        
        //Determinación de existencia de datos de aplicación
        if(dataPushModal !== false){

            //Datos de aplicacion de partida
            let idAplicacion = dataPushModal.id;
            let fechaAplicacion = dataPushModal.fecha;

            //Bandera para determinación de identificación de aplicación
            let aplicacionFlag = true;
            //Variable para fecha actual
            let fechaNueva = null;
            //Valores para fecha
            let dateAux = fechaAplicacion.split(' ')[0];
            let timeAux = fechaAplicacion.split(' ')[1];
            let yearAux = parseInt(dateAux.split('-')[0]);
            let monthAux = parseInt(dateAux.split('-')[1]) - 1;
            let dayAux = parseInt(dateAux.split('-')[2]);
            let hourAux = parseInt(timeAux.split(':')[0]);
            let minuteAux = parseInt(timeAux.split(':')[1]);
            //Variable para control de fecha
            let fechaAux = moment().utc(0).year(yearAux).month(monthAux).date(dayAux).hour(hourAux).minutes(minuteAux).second(0).milliseconds(0);
            //Minutos de diferencia con aplicacion reprogramada
            let minutosDiferencia = 0;

            //Array para nuevas aplicaciones
            let aplicacionesNew = aplicaciones.map(aplicacion => ({ ...aplicacion }));
    
            //Generación de nuevo array de aplicaciones
            aplicacionesNew = aplicacionesNew.map(aplicacionAux => {

                let aplicacionNueva = null;

                if (String(idAplicacion) === String(aplicacionAux.id)) {

                    //Cambio de bandera de identificación
                    aplicacionFlag = false;

                    //Fecha de aplicación
                    fechaNueva = moment(fechaAux);

                    //Cálculo de minutos de diferencia
                    minutosDiferencia = fechaAux.diff(aplicacionAux.fecha, 'minutes');

                    aplicacionNueva = {
                        id: aplicacionAux.id,
                        fecha: fechaAplicacion,
                        dosis: aplicacionAux.dosis,
                        ladoAplicacion: aplicacionAux.ladoAplicacion,
                        reaccion: aplicacionAux.reaccion,
                        realizado: aplicacionAux.realizado
                    };

                } else {

                    //Determinación de identificacion de aplicacion actualizada y reprogramación de aplicaciones
                    if (!aplicacionFlag) {

                        //Determinación de frecuencia de inmunoterapia
                        if ((dataFlag !== false && dataFrecuencia === 6) || (dataFlag === false && typeof frascoData.frecuencia !== 'undefined' && frascoData.frecuencia === 6)) {

                            let diasSemana = {
                                lunes: false,
                                martes: false,
                                miercoles: false,
                                jueves: false,
                                viernes: false,
                                sabado: false,
                                domingo: false
                            };

                            if(dataFlag){

                                diasSemana = dataDiasSemana;

                            }else{

                                if(typeof frascoData.diasSemana !== 'undefined'){

                                    diasSemana = frascoData.diasSemana;

                                }

                            }

                            //Obtención de dia de la semana de la fecha de inicio
                            let diaInicio = fechaNueva.clone().day();
                            //Dia de proxima aplicacion
                            let diaInicioStr = '';
                            switch (diaInicio) {
                                case 0:
                                    diaInicioStr = 'domingo';
                                    break;
                                case 1:
                                    diaInicioStr = 'lunes';
                                    break;
                                case 2:
                                    diaInicioStr = 'martes';
                                    break;
                                case 3:
                                    diaInicioStr = 'miercoles';
                                    break;
                                case 4:
                                    diaInicioStr = 'jueves';
                                    break;
                                case 5:
                                    diaInicioStr = 'viernes';
                                    break;
                                case 6:
                                    diaInicioStr = 'sabado';
                                    break;

                                default:
                                    break;
                            }
                            fechaNueva = fechaNueva.clone().add(distanciaAlSiguienteDia({
                                lunes: diasSemana.lunes,
                                martes: diasSemana.martes,
                                miercoles: diasSemana.miercoles,
                                jueves: diasSemana.jueves,
                                viernes: diasSemana.viernes,
                                sabado: diasSemana.sabado,
                                domingo: diasSemana.domingo
                            }, diaInicioStr, false), 'days');

                        } else {

                            //Fecha de aplicación
                            fechaNueva = moment(aplicacionAux.fecha).add(minutosDiferencia, 'minutes');

                        }

                        aplicacionNueva = {
                            id: aplicacionAux.id,
                            fecha: fechaNueva.clone().format('YYYY-MM-DD HH:mm'),
                            dosis: aplicacionAux.dosis,
                            ladoAplicacion: aplicacionAux.ladoAplicacion,
                            reaccion: aplicacionAux.reaccion,
                            realizado: aplicacionAux.realizado
                        };

                    } else {

                        aplicacionNueva = {
                            id: aplicacionAux.id,
                            fecha: aplicacionAux.fecha,
                            dosis: aplicacionAux.dosis,
                            ladoAplicacion: aplicacionAux.ladoAplicacion,
                            reaccion: aplicacionAux.reaccion,
                            realizado: aplicacionAux.realizado
                        };

                    }

                }

                return aplicacionNueva;

            });
    
            onMultipleInputChange([{ target: { name: 'aplicaciones', value: aplicacionesNew } }]);
            setFormAplicacionesFieldValidation('aplicaciones', true);
            dispatch(setAplicaciones({
                paciente: id,
                aplicaciones: aplicacionesNew
            }));
            handleResetAplicaciones();
    
            setDataPushModal(false);
            setStatusPushModal(false);

        }

    }
    
    const rejectPushModal = () => {

        //Determinación de existencia de datos de aplicación
        if(dataPushModal !== false){

            //Datos de aplicacion de partida
            let idAplicacion = dataPushModal.id;
            let fechaAplicacion = dataPushModal.fecha;

            //Array para nuevas aplicaciones
            let aplicacionesNew = aplicaciones.map(aplicacion => ({ ...aplicacion }));
    
            //Generación de nuevo array de aplicaciones
            aplicacionesNew = aplicacionesNew.map(aplicacionAux => {
    
                let aplicacionNueva = null;
    
                if (String(idAplicacion) === String(aplicacionAux.id)) {
    
                    aplicacionNueva = {
                        id: aplicacionAux.id,
                        fecha: fechaAplicacion,
                        dosis: aplicacionAux.dosis,
                        ladoAplicacion: aplicacionAux.ladoAplicacion,
                        reaccion: aplicacionAux.reaccion,
                        realizado: aplicacionAux.realizado
                    };
    
                } else {
    
                    aplicacionNueva = {
                        id: aplicacionAux.id,
                        fecha: aplicacionAux.fecha,
                        dosis: aplicacionAux.dosis,
                        ladoAplicacion: aplicacionAux.ladoAplicacion,
                        reaccion: aplicacionAux.reaccion,
                        realizado: aplicacionAux.realizado
                    };
    
                }
    
                return aplicacionNueva;
    
            });
    
            onMultipleInputChange([{ target: { name: 'aplicaciones', value: aplicacionesNew } }]);
            setFormAplicacionesFieldValidation('aplicaciones', true);
            dispatch(setAplicaciones({
                paciente: id,
                aplicaciones: aplicacionesNew
            }));
            handleResetAplicaciones();
    
            setDataPushModal(false);
            setStatusPushModal(false);

        }

    }

    const closePushModal = () => {
        setStatusPushModal(false);
    }

    const showNotificacionModal = (msg) => {
        setNotificacionMsg(msg);
        setStatusNotificacionModal(true);
    }

    const aceptNotificacionModal = () => {
        setNotificacion(true);
        setStatusNotificacionModal(false);
    }
    
    const rejectNotificacionModal = () => {
        setNotificacion(false);
        setStatusNotificacionModal(false);
    }

    useEffect(() => {
        if(userAction){
            refetchFase();
            refetchSitio();
            refetchLado();
            refetchReaccion();
            let tipoStatus = false;
            if(typeof tipos !== 'undefined' && tipos.includes(tipo)){
                tipoStatus = true;
            }else if(tipo === ''){
                tipoStatus = null;
            }
            onMultipleInputChange([{ target: { name: 'fase', value: '' } }, { target: { name: 'sitio', value: '' } }, { target: { name: 'alergenos', value: [] } }]);
            setFormTipoFieldValidation('tipo', tipoStatus);
            setFormFaseFieldValidation('fase', null);
            setFormAlergenosFieldValidation('alergenos', true);
            dispatch(setFase({ paciente: id, fase: '' }));
            dispatch(setSitio({ paciente: id, sitio: '' }));
            dispatch(setSitio({ alergenos: id, sitio: [] }));
            handleResetFase();
            handleResetSitio();
            handleResetAlergenos();
            setUserAction(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tipo]);

    useEffect(() => {
        if(userActionRedux){
            if(formTipoFields['tipo'].isValid){
                dispatch(setTipo({
                    paciente: id,
                    tipo: tipo
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formTipoFields['tipo'].isValid]);

    useEffect(() => {
        if(userAction){
            refetchFrasco();
            let faseStatus = false;
            if(typeof fases !== 'undefined' && fases.includes(fase)){
                faseStatus = true;
            }else if(fase === ''){
                faseStatus = null;
            }
            onMultipleInputChange([{ target: { name: 'frasco', value: '' } }, { target: { name: 'concentracion', value: '' } }, { target: { name: 'volumenAlergeno', value: '' } }, { target: { name: 'volumenTotal', value: '' } }, { target: { name: 'sitio', value: '' } }, { target: { name: 'alergenos', value: [] } }, { target: { name: 'aplicaciones', value: [] } }]);
            setFormFaseFieldValidation('fase', faseStatus);
            setFormFrascoFieldValidation('frasco', null);
            setMultipleFormStaticFieldValidation([{ name: 'concentracion', value: true }, { name: 'volumenAlergeno', value: true }, { name: 'volumenTotal', value: true }]);
            setFormAlergenosFieldValidation({ name: 'alergenos', value: true });
            setFormAplicacionesFieldValidation({ name: 'aplicaciones', value: true });
            handleResetFrasco();
            setUserAction(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fase]);

    useEffect(() => {
        if(userActionRedux){
            if(formFaseFields['fase'].isValid){
                dispatch(setFase({
                    paciente: id,
                    fase: fase
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formFaseFields['fase'].isValid]);

    useEffect(() => {
        if(userAction){
            refetchFrascoData();
            let frascoStatus = false;
            if(typeof frascos !== 'undefined' && frascos.map(frasco => frasco.frasco).includes(frasco)){
                frascoStatus = true;
            }else if(frasco === ''){
                frascoStatus = null;
            }
            setFormFrascoFieldValidation('frasco', frascoStatus);
            // setUserAction(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frasco, fecha]);

    useEffect(() => {
        if(userActionRedux){
            if(formStaticFields['fecha'].isValid){
                dispatch(setFecha({
                    paciente: id,
                    fecha: fecha
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formStaticFields['fecha'].isValid]);

    useEffect(() => {
        if(userActionRedux){
            if(formFrascoFields['frasco'].isValid){
                dispatch(setFrasco({
                    paciente: id,
                    frasco: frasco
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formFrascoFields['frasco'].isValid]);

    useEffect(() => {
        if(typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && userAction){
            setTimeout(() => {
                onMultipleInputChange([{ target: { name: 'concentracion', value: String(frascoData.frasco.concentracion) } }, { target: { name: 'volumenAlergeno', value: String(frascoData.frasco.volumenAlergeno) } }, { target: { name: 'volumenTotal', value: String(frascoData.frasco.volumenTotal) } }, { target: { name: 'alergenos', value: frascoData.alergenosActivos } }, { target: { name: 'aplicaciones', value: frascoData.aplicaciones } }]);
                setMultipleFormStaticFieldValidation([{ name: 'concentracion', value: true }, { name: 'volumenAlergeno', value: true }, { name: 'volumenTotal', value: true }]);
                setFormAlergenosFieldValidation('alergenos', true);
                setFormAplicacionesFieldValidation('aplicaciones', true);
                dispatch(setConcentracion({
                    paciente: id,
                    concentracion: String(frascoData.frasco.concentracion)
                }));
                dispatch(setVolumenAlergeno({
                    paciente: id,
                    volumenAlergeno: String(frascoData.frasco.volumenAlergeno)
                }));
                dispatch(setVolumenTotal({
                    paciente: id,
                    volumenTotal: String(frascoData.frasco.volumenTotal)
                }));
                dispatch(setAlergenos({
                    paciente: id,
                    alergenos: frascoData.alergenosActivos
                }));
                dispatch(setAplicaciones({
                    paciente: id,
                    aplicaciones: frascoData.aplicaciones
                }));
                handleResetAlergenos();
                handleResetAplicaciones();
                setUserAction(false);
            }, 100);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frascoData]);
    
    useEffect(() => {
        if(userActionRedux){
            if(formStaticFields['concentracion'].isValid){
                dispatch(setConcentracion({
                    paciente: id,
                    concentracion: concentracion
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [concentracion]);

    useEffect(() => {
        if(userActionRedux){
            if(formStaticFields['volumenAlergeno'].isValid){
                dispatch(setVolumenAlergeno({
                    paciente: id,
                    volumenAlergeno: volumenAlergeno
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [volumenAlergeno]);

    useEffect(() => {
        if(userActionRedux){
            if(formStaticFields['volumenTotal'].isValid){
                dispatch(setVolumenTotal({
                    paciente: id,
                    volumenTotal: volumenTotal
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [volumenTotal]);

    useEffect(() => {
        if(userActionRedux){
            dispatch(setSitio({
                paciente: id,
                sitio: sitio
            }));
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sitio]);

    useEffect(() => {
        if(userActionRedux){
            dispatch(setLado({
                paciente: id,
                lado: lado
            }));
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lado]);

    useEffect(() => {
        if(userActionRedux){
            if(formAlergenosFields['alergenos'].isValid){
                dispatch(setAlergenos({
                    paciente: id,
                    alergenos: alergenos
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alergenos]);

    useEffect(() => {
        if(userActionRedux){
            dispatch(setAplicaciones({
                paciente: id,
                aplicaciones: aplicaciones
            }));
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aplicaciones]);
    
    useEffect(() => {
        if(userActionRedux){
            if(formStaticFields['comentarios'].isValid){
                dispatch(setComentarios({
                    paciente: id,
                    comentarios: comentarios
                }));
            }
            setUserActionRedux(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comentarios]);

    const onSubmit = (e) => {
        e.preventDefault();

        let sitioStatus = true;
        if(sitioData.sitiosFlag && typeof sitioData.sitios !== 'undefined' && sitioData.sitios.length > 0 && !sitioData.sitios.includes(sitio)){
            sitioStatus = false;
        }

        if(formTipoValidationStatus === 'checked' && formStaticValidationStatus === 'checked' && formFaseValidationStatus === 'checked' && formFrascoValidationStatus === 'checked' && isFormStaticValid != null && isFormStaticValid && isFormTipoValid != null && isFormTipoValid && isFormFaseValid != null && isFormFaseValid && isFormFrascoValid != null && isFormFrascoValid && sitioStatus){
            let data = { tipo, fase, fecha, frasco, concentracion, lado: ladoData.ladoFlag, lados: ladoData.lados, reaccion, volumenAlergeno, volumenTotal, alergenos: alergenos.map(alergeno => alergeno._id), aplicaciones: aplicaciones.map(aplicacion => ({
                fecha: aplicacion.fecha,
                dosis: aplicacion.dosis,
                ladoAplicacion: aplicacion.ladoAplicacion,
                reaccion: (['Leve', 'Grande', 'Generalizada'].includes(aplicacion.reaccion)) ? aplicacion.reaccion : '',
                realizado: aplicacion.realizado
            })), comentarios, notificacion };
            if(sitioData.sitiosFlag){
                data = {
                    ...data,
                    sitio
                };
            }
            setToDoAccion(1);
            createInmunoterapia({ data, id, success:  handleCancelar, notificacion: showNotificacionModal});
        }else{
            startFormStaticValidation();
            startFormTipoValidation();
            startFormFaseValidation();
            startFormFrascoValidation();
        }
    }

    useEffect(() => {
        switch (toDoAccion) {
            case 1:
                let data = { tipo, fase, fecha, frasco, concentracion, lado: ladoData.ladoFlag, lados: ladoData.lados, reaccion, volumenAlergeno, volumenTotal, alergenos: alergenos.map(alergeno => alergeno._id), aplicaciones: aplicaciones.map(aplicacion => ({
                    fecha: aplicacion.fecha,
                    dosis: aplicacion.dosis,
                    ladoAplicacion: aplicacion.ladoAplicacion,
                    reaccion: (['Leve', 'Grande', 'Generalizada'].includes(aplicacion.reaccion)) ? aplicacion.reaccion : '',
                    realizado: aplicacion.realizado
                })), comentarios, notificacion };
                if(sitioData.sitiosFlag){
                    data = {
                        ...data,
                        sitio
                    };
                }
                createInmunoterapia({ data, id, success:  handleCancelar, notificacion: showNotificacionModal});
                break;
        
            default:
                break;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notificacion]);

    return (permisos.inmunoterapiaCreate) ? (
        <>
            {(isLoading || isLoadingLado || isLoadingReaccion)
                ? <Loader />
                : <>
                    {(isError || isErrorLado || isErrorReaccion)
                        ? <Error />
                        : <>
                            <div className="row">
                                <div className="col">
                                    <div className={styles.estudioContainer}>
                                        <form onSubmit={onSubmit}>
                                            <div className="row">
                                                <div className={(dataFases.length === 0 && (typeof fases.length === 'undefined' || fases.length === 0)) ? "col" : "col-md-12 col-lg-4"}>
                                                    <ReactSelectSingleInput
                                                        formFieldStatus={ formTipoFields['tipo'].status }
                                                        label="Tipo"
                                                        name="tipo"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        setFormFieldValidation={ setFormTipoFieldValidation }
                                                        value={tipo}
                                                        values={(dataFlag) ? dataTipos : tipos}
                                                    />
                                                </div>
                                                {(faseReset && (dataFases.length > 0 || (typeof fases.length !== 'undefined' && fases.length > 0))) && <div className="col-md-12 col-lg-4">
                                                    <ReactSelectSingleInput
                                                        formFieldStatus={ formFaseFields['fase'].status }
                                                        label="Fase"
                                                        name="fase"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        setFormFieldValidation={ setFormFaseFieldValidation }
                                                        value={fase}
                                                        values={(dataFlag && !userActionDone) ? dataFases : fases}
                                                    />
                                                </div> }
                                                {(dataFases.length > 0 || (typeof fases.length !== 'undefined' && fases.length > 0)) && <div className="col-md-12 col-lg-4">
                                                    <DateTimeInput
                                                        formFieldStatus={ formStaticFields['fecha'].status }
                                                        label="Inicio"
                                                        name="fecha"
                                                        onChange={ handleOnFieldChange }
                                                        placeholder="dd/mm/aaaa hh:mm"
                                                        required={ true }
                                                        requiredIndicator={ true }
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ fecha }
                                                    />
                                                </div> }
                                                {(frascoReset && (dataFrascos.length > 0 || (typeof frascos.length !== 'undefined' && frascos.length > 0))) && <div className={((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && frasco !== '')) ? "col-md-12 col-lg-4" : "col"}>
                                                    <ReactSelectSingleInput
                                                        formFieldStatus={ formFrascoFields['frasco'].status }
                                                        label="Frasco"
                                                        name="frasco"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        setFormFieldValidation={ setFormFrascoFieldValidation }
                                                        value={frasco}
                                                        values={(dataFlag && !userActionDone) ? dataFrascos.map(frasco => frasco.frasco) : frascos.map(frasco => frasco.frasco)}
                                                    />
                                                </div> }
                                                {((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && frasco !== '')) && <div className="col-md-12 col-lg-4">
                                                    <TextInput
                                                        formFieldStatus={ formStaticFields['concentracion'].status }
                                                        label="Concentración"
                                                        name="concentracion"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ concentracion }
                                                    />
                                                </div> }
                                                {((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && tipo !== 'Oraltek' && tipo !== 'Alxoid' && frasco !== '')) && <div className="col-md-12 col-lg-4">
                                                    <TextInput
                                                        formFieldStatus={ formStaticFields['volumenAlergeno'].status }
                                                        label="Vol. alérgeno (ml)"
                                                        name="volumenAlergeno"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ volumenAlergeno }
                                                    />
                                                </div> }
                                                {((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined'  && tipo === 'Oraltek' && frasco !== '')) && <div className="col-md-12 col-lg-4">
                                                    <TextInput
                                                        formFieldStatus={ formStaticFields['volumenTotal'].status }
                                                        label="Vol. total (ml)"
                                                        name="volumenTotal"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ volumenTotal }
                                                    />
                                                </div> }
                                                {((sitioReset && dataFlag && !userActionDone && dataSitiosFlag && frasco !== '') || (sitioReset && typeof sitioData !== 'undefined' && sitioData.sitiosFlag && sitioData.sitios.length > 0 && typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && frasco !== '')) && <div className="col-md-12 col-lg-4">
                                                    <ReactSelectSingleInput
                                                        formFieldStatus="checked"
                                                        label="Sitio de aplicación"
                                                        name="sitio"
                                                        onChange={ handleOnFieldChange }
                                                        required={true}
                                                        requiredIndicator={true}
                                                        value={sitio}
                                                        values={(dataFlag && !userActionDone) ? dataSitios : sitioData.sitios}
                                                    />
                                                </div> }
                                            </div>
                                            {((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && frasco !== '')) && <div className="row mt-1 mb-4">
                                                <div className="col">
                                                    <span className={styles.tabsSubHeader}>Alergenos</span>
                                                </div>
                                            </div>
                                            }
                                            {((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.frasco !== 'undefined' && frasco !== '')) &&<div className="row">
                                                {(alergenosReset) && <div className="col">
                                                    <ReactMultiValueSelectInput
                                                        formsStatus={ formAlergenosFields['alergenos'].status }
                                                        name="alergenos"
                                                        onChange={ handleOnFieldChange }
                                                        placeholder='Selecciona alergenos...'
                                                        setFormFieldValidation={ setFormAlergenosFieldValidation }
                                                        value={alergenos}
                                                        values={(dataFlag && !userActionDone) ? dataAlergenos : ((typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.alergenos !== 'undefined') ? frascoData.alergenos : [])}
                                                    />
                                                </div>}
                                            </div>}
                                            {((dataFlag && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.aplicaciones !== 'undefined' && frasco !== '')) && <div className="row mt-1 mb-4">
                                                <div className="col">
                                                    <span className={styles.tabsSubHeader}>Aplicaciones</span>
                                                </div>
                                            </div>
                                            }
                                            {((dataFlag && aplicacionesReset && frasco !== '') || (typeof frascoData !== 'undefined' && frascoData !== null && typeof frascoData.aplicaciones !== 'undefined' && aplicacionesReset && frasco !== '')) && <div className="row mt-1 mb-4">
                                                <div className="col">
                                                    <MultiFormAplicacionInmunoterapiaNueva
                                                        formsStatus="checked"
                                                        ladoFlag={ladoData.ladoFlag}
                                                        lados={(dataFlag) ? dataLados : ladoData.lados}
                                                        name="aplicaciones"
                                                        onFormsChange={ handleOnFieldChange }
                                                        reaccionFlag={reaccion}
                                                        setFormValidation={ () => {} }
                                                        tipo={tipo}
                                                        value={aplicaciones}
                                                        onAdd={handleAddAplicacion}
                                                        fechaAplicacion={showPushModal}
                                                    />
                                                </div>
                                            </div>
                                            }
                                            <div className="row">
                                                <div className="col">
                                                    <TextAreaInput
                                                        formFieldStatus={ formStaticFields['comentarios'].status }
                                                        label="Comentarios"
                                                        name="comentarios"
                                                        onChange={ handleOnFieldChange }
                                                        required={ false }
                                                        requiredIndicator={ false }
                                                        setFormFieldValidation={ setFormStaticFieldValidation }
                                                        value={ comentarios }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 col-lg-6">
                                                    <LightButton
                                                        block={true}
                                                        disabled={isPending || formTipoValidationStatus === 'checking' || formStaticValidationStatus === 'checking' || formFaseValidationStatus === 'checking' || formFrascoValidationStatus === 'checking' || formAlergenosValidationStatus === 'checking' || formAplicacionesValidationStatus === 'checking'}
                                                        icon="X"
                                                        marginRight={true}
                                                        marginTop={false}
                                                        onClick={handleCancelar}
                                                        text="Cancelar"
                                                        type="button"
                                                    />
                                                </div>
                                                <div className="col-md-12 col-lg-6 mt-md-3 mt-lg-0">
                                                    <PrimaryButton
                                                        block={true}
                                                        disabled={isPending || formTipoValidationStatus === 'checking' || formStaticValidationStatus === 'checking' || formFaseValidationStatus === 'checking' || formFrascoValidationStatus === 'checking' || formAlergenosValidationStatus === 'checking' || formAplicacionesValidationStatus === 'checking' || typeof frascoData === 'undefined' || frascoData === null || typeof frascoData.aplicaciones === 'undefined'}
                                                        icon="Check"
                                                        marginTop={false}
                                                        text="Guardar"
                                                        type="submit"
                                                    />
                                                </div>
                                            </div>
                                            {(dataPostMigracion) &&
                                            <div className="row">
                                                <div className="col">
                                                    <div className={styles.immunotherapyWarning}>
                                                        <strong>Precaución:</strong> Los datos de inmunoterapia existentes provienen de una migración. Revise el historial del paciente antes de crear una nueva inmunoterapia para confirmar la información.
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {(statusPushModal) &&
                                <ModalContainer
                                    state={ statusPushModal }
                                    hide={ closePushModal }
                                    content={ <PushInmunoterapiaModal acept={aceptPushModal} reject={rejectPushModal} /> }
                                />
                            }
                            {(statusNotificacionModal) &&
                                <ModalContainer
                                    state={ statusNotificacionModal }
                                    hide={ rejectNotificacionModal }
                                    content={ <NotificacionInmunoterapiaModal acept={aceptNotificacionModal} msg={notificacionMsg} reject={rejectNotificacionModal} /> }
                                />
                            }
                        </>
                    }
                </>
            }
        </>
    ) : <div className='mt-2'><Forbidden /></div>
}

InmunoterapiaNueva.propTypes = {
    data: PropTypes.object,
    handleCancelar: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
}